<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import DocsNavBar from "./components/DocsNavBar.vue";

const store = useStore();
const windowWidth = ref(window.innerWidth);

// Detectar cambios de tamaño
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  document.body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  document.body.classList.add("bg-gray-100");
});

</script>

<template>
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <!-- Navbar lateral -->
      <div class="col-12 col-md-2">
        <DocsNavBar />
      </div>
      <!-- Contenido principal -->
      <main class="col-12 col-md-10 overflow-auto p-7">
        
        <!-- Sección del manual de usuario (Registro de cuenta) -->
        <hr>
        <h3> Manual de Usuario - Registro de Cuenta <br><img src="../../assets/img/user-manual/UserManual-1.gif" alt="" width="auto" height="80px"> </h3>
        <section class="mt-4">
          <hr>
          <p class="text-gray-700">
            <u><b>  Última Revisión:</b></u> 27/03/2025 <br><br>
            Bienvenid@ a esta breve guía que te ayudará a poder registrarte como usuario de esta nueva plataforma.<br>
          </p>
          <hr>

          <div class="mt-4">
            <h4 class="text-xl font-semibold"> <i class="bi bi-caret-right-fill"></i> Registro de Cuenta.</h4>
            <p class="text-gray-600">Para ingresar por primera vez al sistema puedes dirigirte directamente a la <b><a href="https://app.nexonautomation.com/signup">página de registro</a></b><br> 
              e ingresar los datos solicitados, tu acceso debe ser aprobado previamente para poder acceder al sistema.<br><br>
              Si necesita ayuda adicional para acceder al sistema una vez que se haya registrado, puede enviar un correo electrónico a <b><a href="mailto:elcorreoquequieres@correo.com">app.support@nexonautomation.com</a></b>, y especificar su equipo y cargo para que su solicitud de acceso pueda tramitarse más rapidamente.
            </p>
          </div>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 1 - Crear mi cuenta Nexon</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignUp-1.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">En esta sección encontraremos el formulario de registro, en el que tendremos que introducir nuestros datos principales.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 2 - Registro de datos</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignUp-2.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Deberemos de ingresar nuestro Nombre(s), Apellidos y Correo de Nexon.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 3 - Contraseña</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignUp-3.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Por razones de seguridad, la contraseña debe contener al menos una mayúscula, una minúscula, un dígito y un carácter especial, por ejemplo (= ¡ $ ! # . & - _ / ¿ ? *). </p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 4 - Finalizar registro</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignUp-4.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez rellenado correctamente los campos del formulario, deberá hacer clic en el botón de registro para terminar de crear su cuenta Nexon.</p>
            </div>
          </div><br>
        </section>
        <!-- Final - Sección del manual de usuario (Registro de cuenta) -->


      </main>
    </div>
  </div>
</template>

<style scoped>
  /* Estilos adicionales para asegurar que todo se vea bien */
  main {
    min-height: 100vh; /* Asegurar que el contenido tenga la altura completa */
  }

 h3 {
   text-align: center;
 }
 .bi-caret-right-fill {
  color: #db7535;
 }

 .bi-caret-right {
  color: #db7535;
 }

 .card {
  background: #f5f2f2 ;
 }

</style>
